import type {
  CompositionHeadcountOnlyV3Query,
  CompositionV3DataQuery,
} from '@revelio/data-access';

export type CompositionV3GraphqlResponse = NonNullable<
  CompositionV3DataQuery['composition_v3']
>;

export type CompositionV3HeadcountOnlyGraphqlResponse = NonNullable<
  CompositionHeadcountOnlyV3Query['composition_v3']
>;

/** Payload shape returned by either the full or headcount-only document (overview uses the latter). */
export type CompositionV3AnyGraphqlResponse =
  | CompositionV3GraphqlResponse
  | CompositionV3HeadcountOnlyGraphqlResponse;

/** Metrics as selected by the full composition query; use when indexing dynamic keys on a possibly headcount-only payload. */
export type CompositionV3FullMetrics = NonNullable<
  NonNullable<CompositionV3GraphqlResponse['entities']>[number]['metrics']
>;

const METRIC_KEYS_BEYOND_HEADCOUNT_ONLY_V3 = new Set([
  'salary',
  'tenure',
  'growth_rate',
  'hiring_rate',
  'attrition_rate',
  'gender',
  'ethnicity',
  'role',
  'geography',
  'seniority',
  'education',
  'rics',
  'skills',
]);

export const isCompositionV3FullMetrics = (
  m: unknown
): m is CompositionV3FullMetrics => {
  if (m === null || typeof m !== 'object') {
    return false;
  }
  const record = m as Record<string, unknown>;
  if (!Array.isArray(record.headcount)) {
    return false;
  }
  return Object.keys(record).some((k) =>
    METRIC_KEYS_BEYOND_HEADCOUNT_ONLY_V3.has(k)
  );
};
